import { Icon, IconProps } from "@chakra-ui/react";

export const BRAND = "#006838";

export const COLORS = {
  brand: BRAND,
  brandDark: "#064B2C",
  forest: "#03281A",
  forestMid: "#06382A",
  forestLine: "#0F5A40",
  mint: "#7BE0A4",
  mintSoft: "#E2F3E9",
  page: "#EAF2ED",
  line: "#D3E2D9",
  ink: "#10241A",
  inkSoft: "#3C5A4A",
  onForestSoft: "#A9C7B8",
};

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const ArrowRightIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="M5 12h14M13 6l6 6-6 6" {...stroke} />
  </Icon>
);

export const BuildingIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path
      d="M3 21h18M5 21V7l7-4 7 4v14M9 9h1M14 9h1M9 13h1M14 13h1M9 17h1M14 17h1"
      {...stroke}
    />
  </Icon>
);

export const UsersIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <circle cx="9" cy="8" r="3.5" {...stroke} />
    <path
      d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6M16 4.6a3.5 3.5 0 0 1 0 6.8M18 14.3c2.2.6 3.5 2.5 3.5 5.7"
      {...stroke}
    />
  </Icon>
);

export const ShieldIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="M12 3l8 3v6c0 4.5-3.2 8-8 9-4.8-1-8-4.5-8-9V6z" {...stroke} />
    <path d="M8.5 12l2.5 2.5 4.5-5" {...stroke} />
  </Icon>
);

export const PlayIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="M7 4.5v15l12-7.5z" fill="currentColor" />
  </Icon>
);

export const PauseIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <rect x="6" y="5" width="4" height="14" rx="1" fill="currentColor" />
    <rect x="14" y="5" width="4" height="14" rx="1" fill="currentColor" />
  </Icon>
);

export const VolumeIcon = ({
  muted,
  ...props
}: IconProps & { muted?: boolean }) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="M4 9v6h4l5 4V5L8 9z" {...stroke} />
    {!muted && <path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12" {...stroke} />}
  </Icon>
);

export const StarIcon = ({
  filled,
  ...props
}: IconProps & { filled?: boolean }) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path
      d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z"
      fill={filled ? "#E9A92B" : "none"}
      stroke={filled ? "#B97F0A" : "#6C8A7A"}
      strokeWidth={1.8}
      strokeLinejoin="round"
    />
  </Icon>
);

export const CheckIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="M20 6L9 17l-5-5" {...stroke} />
  </Icon>
);